export default "__VITE_ASSET__BrNHkSOj__"